import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "ModalCreateEditBandeira",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "d-flex flex-column gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "modal-title titulo",
  id: "exampleModalLongTitle"
}
const _hoisted_8 = {
  key: 1,
  class: "modal-title titulo",
  id: "exampleModalLongTitle"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_10 = { class: "col-12 row m-0 p-0" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  class: "d-flex flex-column gap-1",
  style: {"margin-bottom":"18px"}
}
const _hoisted_13 = {
  class: "d-flex flex-row gap-2",
  for: "codigoProduto"
}
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = { class: "d-flex flex-row justify-content-between gap-3" }
const _hoisted_16 = { class: "d-flex flex-column w-100 gap-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex flex-row gap-2" }, " Cor Primária", -1)
const _hoisted_18 = { class: "d-flex flex-column w-100 gap-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex flex-row gap-2" }, " Cor 2", -1)
const _hoisted_20 = { class: "d-flex flex-column w-100 gap-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex flex-row gap-2" }, " Cor 3", -1)
const _hoisted_22 = {
  class: "d-flex flex-column gap-1",
  style: {"position":"relative"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-flex flex-row gap-2",
  for: "descricao"
}, "Logo símbolo", -1)
const _hoisted_24 = {
  class: "shadow-sm d-flex justify-content-center rounded",
  style: {"background-color":"#dedede"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_374_1959)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M23.194 21.9467H2.88147C1.58704 21.9467 0.53772 20.8973 0.53772 19.6029V5.54041C0.53772 4.24597 1.58704 3.19666 2.88147 3.19666H23.194C24.4884 3.19666 25.5377 4.24597 25.5377 5.54041V19.6029C25.5377 20.8973 24.4884 21.9467 23.194 21.9467ZM6.00647 5.93103C4.49631 5.93103 3.27209 7.15525 3.27209 8.66541C3.27209 10.1756 4.49631 11.3998 6.00647 11.3998C7.51663 11.3998 8.74084 10.1756 8.74084 8.66541C8.74084 7.15525 7.51663 5.93103 6.00647 5.93103ZM3.66272 18.8217H22.4127V13.3529L18.1395 9.07971C17.9107 8.8509 17.5397 8.8509 17.3109 9.07971L10.694 15.6967L7.98328 12.986C7.75447 12.7572 7.38347 12.7572 7.15461 12.986L3.66272 16.4779V18.8217Z",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_374_1959" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "25",
          height: "25",
          fill: "white",
          transform: "translate(0.53772 0.0716553)"
        })
      ])
    ])
  ])
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm btn-light-danger send-file"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "imgModal",
    style: {"cursor":"pointer"}
  }, "Enviar arquivo")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "nome-arquivo"
}
const _hoisted_28 = {
  key: 1,
  style: {"width":"100%","height":"18px"}
}
const _hoisted_29 = {
  class: "d-flex flex-column gap-1",
  style: {"position":"relative"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-flex flex-row gap-2",
  for: "descricao"
}, "Banner principal", -1)
const _hoisted_31 = {
  class: "shadow-sm d-flex justify-content-center rounded",
  style: {"background-color":"#dedede"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_374_1959)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M23.194 21.9467H2.88147C1.58704 21.9467 0.53772 20.8973 0.53772 19.6029V5.54041C0.53772 4.24597 1.58704 3.19666 2.88147 3.19666H23.194C24.4884 3.19666 25.5377 4.24597 25.5377 5.54041V19.6029C25.5377 20.8973 24.4884 21.9467 23.194 21.9467ZM6.00647 5.93103C4.49631 5.93103 3.27209 7.15525 3.27209 8.66541C3.27209 10.1756 4.49631 11.3998 6.00647 11.3998C7.51663 11.3998 8.74084 10.1756 8.74084 8.66541C8.74084 7.15525 7.51663 5.93103 6.00647 5.93103ZM3.66272 18.8217H22.4127V13.3529L18.1395 9.07971C17.9107 8.8509 17.5397 8.8509 17.3109 9.07971L10.694 15.6967L7.98328 12.986C7.75447 12.7572 7.38347 12.7572 7.15461 12.986L3.66272 16.4779V18.8217Z",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_374_1959" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "25",
          height: "25",
          fill: "white",
          transform: "translate(0.53772 0.0716553)"
        })
      ])
    ])
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm btn-light-danger send-file"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "imgDestaque",
    style: {"cursor":"pointer"}
  }, "Enviar arquivo")
], -1)
const _hoisted_34 = {
  key: 2,
  class: "nome-arquivo"
}
const _hoisted_35 = {
  key: 3,
  style: {"width":"100%","height":"18px"}
}
const _hoisted_36 = {
  class: "d-flex flex-column gap-1",
  style: {"position":"relative"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-flex flex-row gap-2",
  for: "descricao"
}, "Logo horizontal", -1)
const _hoisted_38 = {
  class: "shadow-sm d-flex justify-content-center rounded",
  style: {"background-color":"#dedede"}
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_374_1959)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M23.194 21.9467H2.88147C1.58704 21.9467 0.53772 20.8973 0.53772 19.6029V5.54041C0.53772 4.24597 1.58704 3.19666 2.88147 3.19666H23.194C24.4884 3.19666 25.5377 4.24597 25.5377 5.54041V19.6029C25.5377 20.8973 24.4884 21.9467 23.194 21.9467ZM6.00647 5.93103C4.49631 5.93103 3.27209 7.15525 3.27209 8.66541C3.27209 10.1756 4.49631 11.3998 6.00647 11.3998C7.51663 11.3998 8.74084 10.1756 8.74084 8.66541C8.74084 7.15525 7.51663 5.93103 6.00647 5.93103ZM3.66272 18.8217H22.4127V13.3529L18.1395 9.07971C17.9107 8.8509 17.5397 8.8509 17.3109 9.07971L10.694 15.6967L7.98328 12.986C7.75447 12.7572 7.38347 12.7572 7.15461 12.986L3.66272 16.4779V18.8217Z",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_374_1959" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "25",
          height: "25",
          fill: "white",
          transform: "translate(0.53772 0.0716553)"
        })
      ])
    ])
  ])
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm btn-light-danger send-file"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "imgBandeira",
    style: {"cursor":"pointer"}
  }, "Enviar arquivo")
], -1)
const _hoisted_41 = {
  key: 4,
  class: "nome-arquivo"
}
const _hoisted_42 = {
  key: 5,
  style: {"width":"100%","height":"18px"}
}
const _hoisted_43 = {
  class: "d-flex flex-column gap-1",
  style: {"position":"relative"}
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-flex flex-row gap-2",
  for: "descricao"
}, "Imagem rodapé ", -1)
const _hoisted_45 = {
  class: "shadow-sm d-flex justify-content-center align-items-center rounded",
  style: {"background-color":"#dedede"}
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_374_1959)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M23.194 21.9467H2.88147C1.58704 21.9467 0.53772 20.8973 0.53772 19.6029V5.54041C0.53772 4.24597 1.58704 3.19666 2.88147 3.19666H23.194C24.4884 3.19666 25.5377 4.24597 25.5377 5.54041V19.6029C25.5377 20.8973 24.4884 21.9467 23.194 21.9467ZM6.00647 5.93103C4.49631 5.93103 3.27209 7.15525 3.27209 8.66541C3.27209 10.1756 4.49631 11.3998 6.00647 11.3998C7.51663 11.3998 8.74084 10.1756 8.74084 8.66541C8.74084 7.15525 7.51663 5.93103 6.00647 5.93103ZM3.66272 18.8217H22.4127V13.3529L18.1395 9.07971C17.9107 8.8509 17.5397 8.8509 17.3109 9.07971L10.694 15.6967L7.98328 12.986C7.75447 12.7572 7.38347 12.7572 7.15461 12.986L3.66272 16.4779V18.8217Z",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_374_1959" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "25",
          height: "25",
          fill: "white",
          transform: "translate(0.53772 0.0716553)"
        })
      ])
    ])
  ])
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm btn-light-danger send-file"
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "fundoBg",
    style: {"cursor":"pointer"}
  }, "Enviar arquivo")
], -1)
const _hoisted_48 = {
  key: 6,
  class: "nome-arquivo"
}
const _hoisted_49 = {
  key: 7,
  style: {"width":"100%","height":"18px"}
}
const _hoisted_50 = {
  class: "gap-2 p-0 pt-5",
  style: {"border":"none","display":"flex","justify-content":"end"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 22 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5625 22.6563C1.5625 23.2779 1.80943 23.874 2.24897 24.3135C2.68851 24.7531 3.28465 25 3.90625 25H17.9688C18.5904 25 19.1865 24.7531 19.626 24.3135C20.0656 23.874 20.3125 23.2779 20.3125 22.6563V6.25001H1.5625V22.6563ZM14.8438 10.1563C14.8438 9.94906 14.9261 9.75034 15.0726 9.60383C15.2191 9.45732 15.4178 9.37501 15.625 9.37501C15.8322 9.37501 16.0309 9.45732 16.1774 9.60383C16.3239 9.75034 16.4062 9.94906 16.4062 10.1563V21.0938C16.4062 21.301 16.3239 21.4997 16.1774 21.6462C16.0309 21.7927 15.8322 21.875 15.625 21.875C15.4178 21.875 15.2191 21.7927 15.0726 21.6462C14.9261 21.4997 14.8438 21.301 14.8438 21.0938V10.1563ZM10.1562 10.1563C10.1562 9.94906 10.2386 9.75034 10.3851 9.60383C10.5316 9.45732 10.7303 9.37501 10.9375 9.37501C11.1447 9.37501 11.3434 9.45732 11.4899 9.60383C11.6364 9.75034 11.7188 9.94906 11.7188 10.1563V21.0938C11.7188 21.301 11.6364 21.4997 11.4899 21.6462C11.3434 21.7927 11.1447 21.875 10.9375 21.875C10.7303 21.875 10.5316 21.7927 10.3851 21.6462C10.2386 21.4997 10.1562 21.301 10.1562 21.0938V10.1563ZM5.46875 10.1563C5.46875 9.94906 5.55106 9.75034 5.69757 9.60383C5.84409 9.45732 6.0428 9.37501 6.25 9.37501C6.4572 9.37501 6.65591 9.45732 6.80243 9.60383C6.94894 9.75034 7.03125 9.94906 7.03125 10.1563V21.0938C7.03125 21.301 6.94894 21.4997 6.80243 21.6462C6.65591 21.7927 6.4572 21.875 6.25 21.875C6.0428 21.875 5.84409 21.7927 5.69757 21.6462C5.55106 21.4997 5.46875 21.301 5.46875 21.0938V10.1563ZM21.0938 1.56251H15.2344L14.7754 0.649423C14.6782 0.454215 14.5284 0.29001 14.3429 0.175281C14.1575 0.0605526 13.9437 -0.00014785 13.7256 8.5609e-06H8.14453C7.92694 -0.000827891 7.71352 0.0596463 7.52871 0.174503C7.34391 0.289359 7.19519 0.453951 7.09961 0.649423L6.64062 1.56251H0.78125C0.57405 1.56251 0.375336 1.64482 0.228823 1.79133C0.08231 1.93784 0 2.13656 0 2.34376L0 3.90626C0 4.11346 0.08231 4.31217 0.228823 4.45869C0.375336 4.6052 0.57405 4.68751 0.78125 4.68751H21.0938C21.301 4.68751 21.4997 4.6052 21.6462 4.45869C21.7927 4.31217 21.875 4.11346 21.875 3.90626V2.34376C21.875 2.13656 21.7927 1.93784 21.6462 1.79133C21.4997 1.64482 21.301 1.56251 21.0938 1.56251Z",
    fill: "#ED2B46"
  })
], -1)
const _hoisted_52 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.3724 4.37237L15.6276 0.627634C15.2258 0.22577 14.6807 2.97177e-06 14.1124 0H2.14286C0.959375 0 0 0.959375 0 2.14286V17.8571C0 19.0406 0.959375 20 2.14286 20H17.8571C19.0406 20 20 19.0406 20 17.8571V5.88759C20 5.31927 19.7742 4.77423 19.3724 4.37237ZM10 17.1429C8.42205 17.1429 7.14286 15.8637 7.14286 14.2857C7.14286 12.7078 8.42205 11.4286 10 11.4286C11.5779 11.4286 12.8571 12.7078 12.8571 14.2857C12.8571 15.8637 11.5779 17.1429 10 17.1429ZM14.2857 3.54821V8.03571C14.2857 8.33156 14.0458 8.57143 13.75 8.57143H3.39286C3.09701 8.57143 2.85714 8.33156 2.85714 8.03571V3.39286C2.85714 3.09701 3.09701 2.85714 3.39286 2.85714H13.5946C13.7367 2.85714 13.873 2.91357 13.9734 3.01406L14.1288 3.16942C14.1785 3.21916 14.218 3.27821 14.2449 3.34321C14.2719 3.4082 14.2857 3.47786 14.2857 3.54821Z",
  fill: "#ED2B46"
}, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja excluir bandeira?", -1)
const _hoisted_59 = { class: "dialog-footer d-flex flex-row gap-3 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.bandeiraSelected.codBandeira)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_7, "Editar Bandeira"))
                : (_openBlock(), _createElementBlock("h5", _hoisted_8, "Cadastrar Bandeira"))
            ]),
            _hoisted_9
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.createOrUpdate && _ctx.createOrUpdate(...args))),
            name: "formulario",
            enctype: "multipart/form-data",
            class: "modal-body",
            id: "modalBody",
            style: {"padding":"1rem"}
          }, [
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("input", {
                style: {"display":"none"},
                name: "codBandeira",
                value: _ctx.bandeiraSelected.codBandeira
              }, null, 8, _hoisted_11),
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _createTextVNode("Nome da bandeira "),
                  (!_ctx.bandeiraSelected.descricao)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.bandeiraSelected.descricao,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bandeiraSelected.descricao) = $event)),
                  name: "descricao",
                  placeholder: "Digite o código do produto"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("li", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_input, {
                    class: "inputColor",
                    type: "color",
                    modelValue: _ctx.bandeiraSelected.cor1,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bandeiraSelected.cor1) = $event)),
                    name: "cor1",
                    placeholder: "Digite o código do produto"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_el_input, {
                    class: "inputColor",
                    type: "color",
                    modelValue: _ctx.bandeiraSelected.cor2,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bandeiraSelected.cor2) = $event)),
                    name: "cor2",
                    placeholder: "Digite o código do produto"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("li", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_el_input, {
                    class: "inputColor",
                    type: "color",
                    modelValue: _ctx.bandeiraSelected.cor3,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bandeiraSelected.cor3) = $event)),
                    name: "cor3",
                    placeholder: "Digite o código do produto"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("li", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_el_image, {
                    src: _ctx.bandeiraSelected?.imgModal,
                    fit: "contain",
                    style: {"height":"100px"}
                  }, {
                    error: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }, 8, ["src"])
                ]),
                _hoisted_26,
                _createElementVNode("input", {
                  type: "file",
                  ref: "imgModal",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleImgFileChange($event, 'imgModal'))),
                  name: "imgModal",
                  id: "imgModal",
                  placeholder: "Digite a descrição do produto",
                  class: "select-file"
                }, null, 544)
              ]),
              (_ctx.fileRefs.imgModal)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.fileRefs.imgModal.name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_28)),
              _createElementVNode("li", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_el_image, {
                    src: _ctx.bandeiraSelected?.imgDestaque,
                    fit: "contain",
                    style: {"height":"100px"}
                  }, {
                    error: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  }, 8, ["src"])
                ]),
                _hoisted_33,
                _createElementVNode("input", {
                  type: "file",
                  ref: "imgDestaque",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleImgFileChange($event, 'imgDestaque'))),
                  name: "imgDestaque",
                  id: "imgDestaque",
                  placeholder: "Digite a descrição do produto",
                  class: "select-file"
                }, null, 544)
              ]),
              (_ctx.fileRefs.imgDestaque)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.fileRefs.imgDestaque.name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_35)),
              _createElementVNode("li", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_el_image, {
                    src: _ctx.bandeiraSelected?.imgBandeira,
                    fit: "contain",
                    style: {"height":"100px"}
                  }, {
                    error: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 1
                  }, 8, ["src"])
                ]),
                _hoisted_40,
                _createElementVNode("input", {
                  type: "file",
                  ref: "imgBandeira",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleImgFileChange($event, 'imgBandeira'))),
                  name: "imgBandeira",
                  id: "imgBandeira",
                  placeholder: "Digite a descrição do produto",
                  class: "select-file"
                }, null, 544)
              ]),
              (_ctx.fileRefs.imgBandeira)
                ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.fileRefs.imgBandeira.name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_42)),
              _createElementVNode("li", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_el_image, {
                    src: _ctx.bandeiraSelected?.fundoBg,
                    fit: "contain",
                    style: {"height":"100px"}
                  }, {
                    error: _withCtx(() => [
                      _hoisted_46
                    ]),
                    _: 1
                  }, 8, ["src"])
                ]),
                _hoisted_47,
                _createElementVNode("input", {
                  type: "file",
                  ref: "fundoBg",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleImgFileChange($event, 'fundoBg'))),
                  name: "fundoBg",
                  id: "fundoBg",
                  placeholder: "Digite a descrição do produto",
                  class: "select-file"
                }, null, 544)
              ]),
              (_ctx.fileRefs.fundoBg)
                ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.fileRefs.fundoBg.name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_49))
            ]),
            _createElementVNode("div", _hoisted_50, [
              (_ctx.bandeiraSelected.codBandeira)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    variant: "primary",
                    text: "Excluir",
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_51
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                type: "submit",
                text: "Salvar",
                disabled: !_ctx.bandeiraSelected.descricao,
                variant: "primary"
              }, {
                default: _withCtx(() => [
                  (_ctx.loadSalvar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_55, _hoisted_57))
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "Confirme sua ação",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_59, [
          _createElementVNode("button", {
            class: "btn btn-light-danger",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogVisible = false))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-light-danger",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deletarBandeira(_ctx.bandeiraSelected.codBandeira)))
          }, "Confirmar")
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_58
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}